import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-efd01ff6")

_pushScopeId("data-v-efd01ff6")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "header-left" }, [
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-bars fa-xl" })
  ]),
  /*#__PURE__*/_createVNode("span", null, " home ")
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "header-right" }, " 알림 ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("header", null, [
    _hoisted_1,
    _hoisted_2
  ]))
})